import { render } from "./StoreAllowancePolicy.vue?vue&type=template&id=ab5be5f8&scoped=true"
import script from "./StoreAllowancePolicy.vue?vue&type=script&lang=js"
export * from "./StoreAllowancePolicy.vue?vue&type=script&lang=js"

import "./StoreAllowancePolicy.vue?vue&type=style&index=0&id=ab5be5f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5be5f8"]])

export default __exports__